// import { TwitterTweetEmbed } from 'react-twitter-embed'
import { Content } from '../../../types/Content'
import ContentBase from '../ContentBase'
import styles from './TwitterPost.module.css'
import globalStyles from '../../../styles/overlay.module.css'
import { ExerciseProps } from '../../../common/utils/feed'
import { useSwiperSlide } from 'swiper/react'
import { ResponseStatus } from '../../../common/utils/exercise'

interface TwitterPostProps {
  isExercise: boolean
  post: Content
  exerciseProps?: ExerciseProps
}

const TwitterPost = ({ isExercise, post, exerciseProps }: TwitterPostProps) => {
  const { title, data, context, type } = post
  const swiperSlide = useSwiperSlide()

  if (isExercise && swiperSlide.isActive && !exerciseProps?.stepResponse) {
    exerciseProps?.onResponseSubmit(exerciseProps?.id, ResponseStatus.COMPLETE)
  }

  const handleOnClick = () => {
    console.log('clicked')
  }

  return isExercise ? (
    <div className={styles.container}>
      <div className={globalStyles.overlay} onClick={handleOnClick}></div>
      {/* <TwitterTweetEmbed tweetId={id} /> */}
    </div>
  ) : (
    <ContentBase context={context} data={data} title={title} type={type}>
      <div className={styles.container}>
        <div className={globalStyles.overlay} onClick={handleOnClick}></div>
        {/* <TwitterTweetEmbed tweetId={id} /> */}
      </div>
    </ContentBase>
  )
}

export default TwitterPost
